import type { ReactNode } from 'react';

import { cn } from '@shared/lib/utils';

import { Tabs, TabsList, TabsTrigger } from './tabs';

export type ViewMode = 'cards' | 'table';

interface ViewModeTabsProps {
  value: ViewMode;
  onValueChange: (value: ViewMode) => void;
  labels: {
    cards: string;
    table: string;
  };
  toolbar?: ReactNode;
  className?: string;
  listClassName?: string;
  children?: ReactNode;
}

export function ViewModeTabs({
  value,
  onValueChange,
  labels,
  toolbar,
  className,
  listClassName,
  children,
}: ViewModeTabsProps) {
  return (
    <Tabs
      value={value}
      onValueChange={(nextValue) => {
        onValueChange(nextValue as ViewMode);
      }}
      className={cn('w-full', className)}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <TabsList
            variant="secondary"
            className={cn('hidden overflow-x-auto overflow-y-hidden md:flex', listClassName)}
          >
            <TabsTrigger variant="secondary" value="cards" className="ml-0">
              {labels.cards}
            </TabsTrigger>
            <TabsTrigger variant="secondary" value="table" className="-ml-px">
              {labels.table}
            </TabsTrigger>
          </TabsList>
          {toolbar ? (
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
              {toolbar}
            </div>
          ) : null}
        </div>
        {children}
      </div>
    </Tabs>
  );
}
